import FJImageManipulationLeft from './FJImageManipulationLeft';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageManipulation from '../../../redux/action/FJActionImageManipulation';
import { useCallback } from 'react';
import {
    setSliceSwitchOldPhotoRestorationAction,
    setSliceSwitchPhotoColorizeAction,
} from '../../../redux/slices/FJSliceImageManipulation';
import FJUtil from '../../../util/FJUtil';
import FJActionCommon from '../../../redux/action/FJActionCommon';
const FJImageManipulationLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const switchOldPhotoRestoration = useSelector(state => state.imageManipulation.switchOldPhotoRestoration);
    const switchPhotoColorize = useSelector(state => state.imageManipulation.switchPhotoColorize);
    const imageEnhancerData = useSelector(state => state.imageManipulation.imageEnhancerData);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const switchScratchOrFold = useSelector(state => state.imageManipulation.switchScratchOrFold);
    const photoColorizeNum = useSelector(state => state.imageManipulation.useNumFunctionData.photoColorize);

    const onSwitchOldPhotoRestoration = value => {
        dispatch(setSliceSwitchOldPhotoRestorationAction(value));
    };
    const onSwitchPhotoColorize = value => {
        dispatch(setSliceSwitchPhotoColorizeAction(value));
    };
    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageManipulation.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(0));
    }, [dispatch, taskStatus]);

    return (
        <FJImageManipulationLeft
            switchOldPhotoRestoration={switchOldPhotoRestoration}
            switchPhotoColorize={switchPhotoColorize}
            onSwitchOldPhotoRestoration={onSwitchOldPhotoRestoration}
            onSwitchPhotoColorize={onSwitchPhotoColorize}
            creditNumber={creditNumber}
            taskStatus={taskStatus}
            onGenerate={_onGenerate}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            imageEnhancerData={imageEnhancerData}
            switchScratchOrFold={switchScratchOrFold}
            photoColorizeNum={photoColorizeNum}
        />
    );
};
export default FJImageManipulationLeftContainer;
